import { TABLE_INITIAL_STATE, TableActionTypes, useDataTable } from 'web-library';
import React from 'react';
import { useParams } from 'react-router-dom';
import { useGetTransactionLog } from '../api-refactored/user-group-access-configuration/useGetTransactionLog';
import TransactionLogModalDetails from './TransactionLogModalDetails';

interface TransactionLogModalProps {
  modalState: boolean;
  setOpenModalState: React.Dispatch<React.SetStateAction<boolean>>;
  requestType: string;
  institutionUuid?: string;
  transactionLogUuid?: string;
}

const TransactionLogModal = ({
  modalState,
  setOpenModalState,
  requestType,
  institutionUuid,
  transactionLogUuid,
}: TransactionLogModalProps) => {
  const { uuid } = useParams<{ uuid: string }>();

  const dataTableHook = useDataTable({
    ...TABLE_INITIAL_STATE,
    sortColumn: 'dateTime',
    order: 'asc',
    size: 5,
    page: 0,
    search: '',
  });

  const { dispatch: tableDispatch, state } = dataTableHook;

  const { refetch } = useGetTransactionLog({
    apiPathParam: {
      page: state.page,
      pageSize: state.size,
      order: state.order,
    },
    onSuccess: (res) => {
      tableDispatch({
        type: 'UPDATE_DATA',
        payload: {
          data: res.content,
          count: res.totalElements,
        },
      } as TableActionTypes);
    },
    requestType,
    uuid: transactionLogUuid || institutionUuid || uuid,
    enabled: modalState && (!!transactionLogUuid || !!institutionUuid || !!uuid),
  });

  return (
    <TransactionLogModalDetails
      dataTableHook={dataTableHook}
      refetch={refetch}
      openModalState={modalState}
      setOpenModalState={setOpenModalState}
    />
  );
};

export default TransactionLogModal;
